import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../../../app/guards'
import { taxRatesQueryOptions } from '../../../../features/finance/queries'
import { EditInvoicePage } from '../../../../features/sales/invoice-pages'
import { salesSettingsQueryOptions } from '../../../../features/sales/queries'
import { editInvoiceSearchSchema } from '../../../../features/sales/search'

export const Route = createFileRoute('/_app/invoices/$invoiceId/edit')({
  staticData: { crumb: 'invoiceEdit' },
  validateSearch: editInvoiceSearchSchema,
  beforeLoad: ({ context }) => requirePermission(context.session, 'invoices.create'),
  loader: async ({ context }) => {
    await Promise.all([
      context.queryClient.ensureQueryData(salesSettingsQueryOptions),
      context.queryClient.ensureQueryData(taxRatesQueryOptions),
    ])
  },
  component: EditInvoicePage,
})
